import { useMemo } from 'react';
import { useFreeShippingEligible } from '@/SearchResults/ResultTile/hooks';
import SortOption from '~/constants/SortOption';

const useConditionalSortItems = () => {
  const isFreeShippingEligible = useFreeShippingEligible();

  return useMemo(
    () =>
      isFreeShippingEligible
        ? [{ label: 'Free Shipping', key: SortOption.FreeShipping }]
        : [],
    [isFreeShippingEligible]
  );
};

const useSortItems = () => {
  const conditionalSortItems = useConditionalSortItems();

  return useMemo(
    () => [
      { label: 'Recommended', key: SortOption.MostPopular },
      ...conditionalSortItems,
      { label: 'Great Deal', key: SortOption.GreatDeal },
      { label: 'Soonest Availability', key: SortOption.AcquisitionTime },
      { label: 'Newest Inventory', key: SortOption.NewestInventory },
      { label: 'Highest Price', key: SortOption.HighestPrice },
      { label: 'Lowest Price', key: SortOption.LowestPrice },
      { label: 'Make & Model', key: SortOption.MakeAndModel },
      { label: 'Newest Year', key: SortOption.NewestYear },
      { label: 'Lowest Mileage', key: SortOption.LowestMileage }
    ],
    [conditionalSortItems]
  );
};

export default useSortItems;
